import React from "react";
import {
    Container,
    FormGroup,
} from 'reactstrap';
import { colorTheme } from "../../utils/constants";
import { IonButton, IonNote, IonRow } from "@ionic/react";

export default class UploadBankStatement extends React.Component{
    constructor(props){
        super(props);
        this.inputFileRef = React.createRef();
    }

    handleSelectFile() {
        /*Collecting node-element and performing click*/
        this.inputFileRef.current.click();
    }

    render(){
        return (
            <Container>
                <FormGroup row className="mt-3">
                    <h5>Please start by selecting the bank statement you wish to upload.</h5>
                </FormGroup>

                <IonRow className='my-3 justify-content-center align-items-center'>
                    <input
                        type="file"
                        style={{ display: 'None', marginTop: '20%', marginBottom: '15%' }}
                        ref={this.inputFileRef}
                        onChange={ (event) => this.props.handleChangeFile(event)}
                    />
                    <IonButton
                        style={{ backgroundColor: colorTheme["primary"]["700"], borderRadius: "10px" }}
                        onClick={() => this.handleSelectFile()}
                        disabled={this.props.readOnly}
                        >
                        {this.props.fileName? "Change" : "Select" } Bank Statement
                    </IonButton>
                    {this.props.fileName?
                    (<h6 className="ml-2">selected
                    <span style={{color: 'blue'}}>{this.props.fileName}</span></h6>)
                         : <span></span>}
                </IonRow>
                <FormGroup row className="my-3 justify-content-center align-items-center">
                    <IonNote>Accepted formats are csv, excel (xls, xlsx) and pdf</IonNote>
                </FormGroup>
                <FormGroup row>
                    <h6>
                        Note: We do not store your bank statement. In the next step you will choose the transactions to store/save.
                    </h6>
                </FormGroup>
            </Container>);
    }
}